var config = {
	CANVAS_WIDTH: window.innerWidth,
	CANVAS_HEIGHT: window.innerHeight
};

var loadGroup = null;
var gameGroup = null;
var resultGroup= null;
var begin = null;
var rulePage = null;
var gamePage = null;
var person = null;
var score=null;
var total=0;
var gw= 0;
var timeout= 0;
var canGetHeight=0;
//初始化
var game = new Phaser.Game(config.CANVAS_WIDTH, config.CANVAS_HEIGHT, Phaser.AUTO, 'game');
//创建游戏states状态
game.states = {};
//游戏初始化，创建启动boot state
game.states.boot = function() {
	this.preload = function() {
		//判断是否移动端
		if(!game.device.desktop) {
			//	this.scale.scaleMode - Phaser.ScaleManager.EXACT_FIT;
			//设置适配模式（全屏）
			this.scale.forcePortrait = true;
			//设置背景色
			game.stage.backgroundColor = '#000';
			game.scale.refresh();
		}

	}
	this.create = function() {
		//启动加载preload state
		game.state.start('preload');
	}
};
//游戏资源加载
game.states.preload = function() {
	this.preload = function() {
		//资源加载
		game.load.image('gamebg', '/public/assets/images/pie/main_bg.jpg');
		game.load.image('mainbg', '/public/assets/images/pie/main_bg.jpg');
		game.load.image('rulebg', '/public/assets/images/pie/main_bg.jpg');
		//		game.load.image('person','/public/assets/images/pie/person.gif');
		//		game.load.image('persons','/public/assets/images/pie/person1.png');
		//添加精灵图
		game.load.spritesheet('person', '/public/assets/images/pie/ox2.png', 75, 75);

		game.load.image('bread1', '/public/assets/images/pie/bread1.png');
		game.load.image('bread2','/public/assets/images/pie/bomb.png');
		game.load.image('bread3', '/public/assets/images/pie/bread3.png');
		game.load.image('bread4','/public/assets/images/pie/bomb2.png');
		game.load.image('bread5','/public/assets/images/pie/bread5.png');
		game.load.image('bread6', '/public/assets/images/pie/bread6.png');
		game.load.image('bread7', '/public/assets/images/pie/bread7.png');
		game.load.image('bread8', '/public/assets/images/pie/bread4.png');
		game.load.image('bread9', '/public/assets/images/pie/bomb3.png');
		game.load.image('bread10', '/public/assets/images/pie/bread2.png');
		
		game.load.image('bombcrack','/public/assets/images/pie/bombcrack2.png');
		loadGroup = game.add.group();
		game.add.text(game.world.centerX - 30, game.world.centerY, '0%', {
			fill: '#fff'
		}, loadGroup).anchor.setTo(0, 0);
		game.load.onFileComplete.add(function() {
			loadGroup.getChildAt(0).text = game.load.progress + '%';
		}, this);
	}
	this.create = function() {
		gamePage = document.getElementById("game");
		gamePage.style.transition="none";
		gamePage.style.webkitTransition="none";
		gamePage.style.transform = 'translateX(100%)';
		gamePage.style.webkitTransform = 'translateX(100%)';
		setTimeout(function() {
			game.load.onFileComplete.removeAll();
			loadGroup.visible = false;
			document.querySelector(".main-bg").style.display = "block";
		}, 200);
		begin = document.getElementById("begin");
		rulePage = document.querySelector('.rule');
		begin.addEventListener("click", function(e) {
			e.preventDefault();
			game.state.start('story');
		});
	}
};

game.states.story = function() {
	this.create = function() {
		rulePage.style.transform = 'translateX(0)';
		rulePage.style.webkitTransform = 'translateX(0)';
		rulePage.addEventListener("transitionend", rule);
		rulePage.addEventListener("webkitTransitionEnd", rule);
		document.getElementById("go").addEventListener('click', function() {
			gamePage.style.transition="transform .6s";
			gamePage.style.webkitTransition="-webkit-transform .6s";
			gamePage.style.transform = 'translateX(0)';
			gamePage.style.webkitTransform = 'translateX(0)';
			game.state.start('play');
		});
		gamePage.addEventListener("transitionend", ready);
		gamePage.addEventListener("webkitTransitionEnd", ready);
		
		document.getElementById("again").addEventListener("click",function(){
			location.href=location.href;
		});
		document.querySelector(".remind").addEventListener("transitionend", showBtn);
		document.querySelector(".remind").addEventListener("webkitTransitionEnd", showBtn);
	}
}
function rule(){
	var breads=document.querySelectorAll(".bread");
	for(var i=0;i<breads.length;i++){
		breads[i].className+=" dropdowns";
	}
	var bread7=document.querySelector(".bread7");
	bread7.addEventListener('animationend',move);
	bread7.addEventListener('webkitAnimationEnd',move);
	
}
function showBtn(){
	var go=document.getElementById("go");
	go.style.transform="scale(1)";
	go.style.webkitTransform="scale(1)";
	setTimeout(function(){
		go.className+=" breath";
	},200);
}
function move(){
		document.querySelector(".score").style.transform='translateX(0)';
		document.querySelector(".score").style.webkitTransform='translateX(0)';
		document.querySelector(".remind").style.opacity=1;
}
function ready() {
	document.querySelector('.tan_bg').style.display = 'block';
}

var background = '';
var dropItems  = [];
game.states.play = function() {
	this.create = function() {
		game.physics.startSystem(Phaser.Physics.Arcade);
		background = game.add.sprite(game.world.centerX, game.world.centerY, "gamebg");
		background.anchor.setTo(.5, .5);
		//设置背景图的宽高为游戏框的高宽
		background.height = game.world.height;
		background.width = game.world.width;

		gameGroup = game.add.group();
		//设置这个group内所有对象都获得物理身体
		gameGroup.enableBody = true;
		//创建人物
		//		person=gameGroup.create(game.world.centerX,game.height-90,'persons');
		person = game.add.sprite(game.world.centerX, game.height - 90, 'person');
		person.frame = 6;
		//缩放
		person.scale.setTo(1, 1);
		//中心点
		person.anchor.setTo(.5, .5);
		//设置可拖动
		person.inputEnabled = true;
		person.inputEnabled = true;
		//保证person拥有物理特性
		game.physics.enable(person, Phaser.Physics.ARCADE);
		//设置人物可拖动
		person.input.enableDrag();
		//给人物添加补间动画
		person.animations.add('left', [6, 5, 4, 3, 2, 1, 0], 0, true);
		person.animations.add('right', [7, 8, 9, 10, 11, 12, 13], 0, true);
//		person.input.startDrag=function(e){
//			console.log(1);
//		}
//		game.input.touch.onTouchStart = function() {
//			console.log(1);
//		}
//		game.input.touch.onTouchMove=function(){
//			console.log(2);
//			person.animations.play('left');
//		}
//		game.input.touch.onTouchEnd=function(){
//			console.log(3);
//			person.animations.stop();
//			person.frame = 6;
//		}
		game.add.group(gameGroup);
		resultGroup=game.add.group();
		//绘制文本
		var scoreText=game.add.text(20,20,"score：",{
			font:'17px SimHei',
			fill:'#fff'
		},resultGroup);
		score=game.add.text(80,20,'0',{
			font:'17px SimHei',
			fill:'#fff'
		},resultGroup);
		var perWidth=person.width;
		gw=(config.CANVAS_WIDTH-perWidth)/2;
		canGetHeight = game.height -person.height - 60;
		var ready = document.querySelector(".ready_p2");
		ready.addEventListener("animationend", go);
		ready.addEventListener("webkitAnimationEnd", go);
		dropItems=gameGroup.getChildAt(0);
	}
	this.update = function() {
		//监听人物移动到边界
		var centerX = game.world.centerX;
		var gameHeight = game.height;
		person.x > centerX + gw && (person.x = centerX + gw);
		person.x < centerX - gw && (person.x = centerX - gw);
		person.y = gameHeight - 90;
		//监听碰撞
		dropItems.forEach(function(b){
			game.physics.arcade.collide(b,person,null,function(){
				if(b.y<canGetHeight){
					if(b.dropType=='bread'){
						b.destroy();
						total+=100;
						score.text=total;
					}else{
						//移除所有循环事件
						game.time.events.removeAll();
						gameGroup.getChildAt(0).destroy();
						var bomb=game.add.sprite(b.x,b.y,'bombcrack');
						//禁止拖动
						person.input.disableDrag();
						bomb.anchor.setTo(.5,.5);
						bomb.scale.setTo(.3,.3);
						//tween关联，添加补间动画
						game.add.tween(bomb.scale).to({
							x: 1,
							y: 1
						}, 300).start().onComplete.add(function() {
							bomb.destroy();
							document.querySelector(".scores").innerHTML=total;
							document.querySelector('.gameover').style.display='block';
						});
					}
				}else{
					b.destroy();
				}
			})
		})
		//键盘事件
		var cursors = game.input.keyboard.createCursorKeys();
		//  重设player运行速率
		person.body.velocity.x = 0;
		if(cursors.left.isDown) {
			//  左移
			person.body.velocity.x = -500;
			person.animations.play('left');
		} else if(cursors.right.isDown) {
			//  右移
			person.body.velocity.x = 500;
			person.animations.play('right');
		} else {
			//  不动
			person.animations.stop();
			person.frame = 6;
		}

	};
}

function go() {
	document.querySelector('.tan_bg').style.display = 'none';
	//循环事件
	game.time.events.loop(400,createDropItem);
	//gameGroup.getChildAt(0).loadTexture('person');

}

var DROP_TYPE=['bread','bomb','bread','bomb','bread','bread','bread','bread','bomb','bread'];
function createDropItem(){
	var index=Math.ceil(DROP_TYPE.length*Math.random());
	var x=game.world.width*Math.random()-40;
	if(x<20){
		x=50;
	}
	//创建馅饼物体
	var dropItem=game.add.sprite(x,0,'bread'+index);
	
	//定义掉落物体类型
	var type=DROP_TYPE[index-1];
	dropItem.dropType=type;
	if(type!='bread'){
		dropItem.scale.setTo(.5,.5);
	}else{
		dropItem.scale.setTo(.2,.2);
	}
	
	dropItem.y=0;
	game.physics.arcade.enable(dropItem);
	gameGroup.getChildAt(0).add(dropItem);
	
	var bounce=game.add.tween(dropItem);
	var runTime=2500+100*Math.random()+timeout*10;
	//掉落动画，当落到地面时消失
	bounce.to({
		y:game.world.height-dropItem.height
	},runTime);
	//监听动画完成
	bounce.onComplete.addOnce(function(){
		dropItem.destroy();
	},this);
	bounce.start();
}
game.state.add('boot', game.states.boot);
game.state.add('preload', game.states.preload);
game.state.add('story', game.states.story);
game.state.add('play', game.states.play);

game.state.start('boot');